import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Form, { Heading } from '../Form';
import Button from '../Button';
import Toast from '../Toast';
import Row from '../Row';
import Col from '../Col';
import SuiteAreas from './SuiteAreas';
import { savePropertyCommonAreas } from '../../store/actions/properties';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectCommonAreas } from '../../store/selectors/commonAreas';
import { selectPropertyCommonAreas } from '../../store/selectors/propertyCommonAreas';

class ConfigureCommonAreaForm extends Component {
    state = {
        selectedAreas: [],
        commonAreasList: []
    }

    componentDidMount() {
        let { commonAreas, propertyCommonAreas } = this.props;

        let otherAreasList = []
        propertyCommonAreas.otherCommonAreas.map((oItem => {
            if (oItem.type === 'Other') {
                otherAreasList.push(oItem);
            }
        }))
        
        let object = {
            id: 'Other',
            type: 'Other',
            name: 'Other',
            customLabel: ''
        }
        this.setState({ selectedAreas: propertyCommonAreas.commonAreas, commonAreasList: [...commonAreas, ...otherAreasList,  ...[object]] })
    }

    handleAreas = (id, value, area) => {
        let areas = this.state.selectedAreas;
        let commonAreas = this.state.commonAreasList;
        let index = areas.findIndex(data => data.id === id);
        if (index === -1) {
            let object;
            if (area.name === 'Other') {
                object = {
                    "id": 'Other',
                    "name": "Other",
                    "type": "Other",
                    "customLabel": ""
                };
                areas = [...areas, object]
            } else {
                areas = [...areas, area]
            }
            this.setState({ selectedAreas: areas })
        } else {
            let filteredAreas = areas.filter(a => a.id !== id)
            if(value && value.new) {
               let filtereddata =  commonAreas.filter(a => a.id !== id)
               this.setState({ commonAreasList: filtereddata})
            }
            this.setState({ selectedAreas: filteredAreas })
        }
    }

    savePropertyCommonAreas() {
        const { property, user, onSaveProperyCommonAreas, onClose, commonAreas, propertyCommonAreas } = this.props;
        let { selectedAreas } = this.state;

            let data = selectedAreas.filter(s => s.id !== 'Other')
            let filterData = data.map(s => {
                if(s && s.new) {
                    return {
                        name: s.name,
                        type: s.type,
                        customLabel: s.customLabel
                    }
                } else {
                    return s
                }
            })

            
        let params = {
            "PropertyId": property.id,
            "UserId": user.id,
            "CommonAreas": filterData
        }
        onSaveProperyCommonAreas(params);
        onClose()
    }


    onEnterText(value, id) {
        let selectedAreas = this.state.selectedAreas;
        let data = selectedAreas.map((s, i) => {
            if (s.id === id) {
                return { ...s, customLabel: value }
            } else {
                return s
            }
        })
        this.setState({ selectedAreas: data })
    }

    onAddArea(id) {
        let areas = this.state.selectedAreas;
        let suiteAreas = this.state.commonAreasList;

        let data = areas.filter(item => item.id === id);
        if (data.length > 0) {
            if (data[0] && data[0].customLabel && data[0].customLabel.trim()) {
                const min = 1;
                const max = 100;
                const randomNumber = min + Math.random() * (max - min);

                let obj = {
                    id: randomNumber,
                    new: true,
                    name: data[0].name,
                    type: data[0].type,
                    customLabel: data[0].customLabel.trim()
                }
                suiteAreas = [...suiteAreas, obj]
                areas = [...areas, obj]

                this.setState({ commonAreasList: suiteAreas, selectedAreas: areas });
            } else {
                alert('Please Enter custom label name for adding other check box');
                // let filtereddata = areas.filter(object => object.other !== 'Other')
                this.setState({ areas: areas});
            }
        }
    }

    render() {
        let { property, onClose } = this.props;

        const { selectedAreas } = this.state;

        return (
            <Form
                headline={'Configure Common Areas'}
                onClose={onClose}
                onSubmit={() => this.savePropertyCommonAreas()}
                actions={(
                    <>
                    <div/>
                        <Button
                            color="teal"
                            size="small"
                            label="Save Common Areas"
                            onClick={() => this.setState({
                                buttonPressed: 'SaveAndClose'
                            })}
                            disabled={false}
                        />
                    </>
                )}
                component={(
                    // <>
                    //     <div>{commonAreas.map(area => <div>{area.name}</div>)}</div>
                    // </>
                    <>
                        <Row mdCenter>
                            <Col
                                xs="12"
                                md="6"
                            >
                                <>
                                    <Toast
                                        message={(
                                            <>
                                                You are adding common areas to <strong>{property.name}</strong>.
                                            </>
                                        )}
                                    />
                                    <br />
                                    <br />
                                </>
                                <Heading>Common Areas</Heading>
                                <Row>
                                    {this.state.commonAreasList.map((area, i) => {
                                        let value = this.state.selectedAreas.find(data => data.id === area.id);

                                        return (
                                            <Col
                                                xs="12"
                                                md="6"
                                            >
                                                <SuiteAreas
                                                    label={area.name}
                                                    type='checkbox'
                                                    id={area.id}
                                                    value={value && value.id ? value.id : null}
                                                    textValue={value && value.customLabel ? value.customLabel : ''}
                                                    disabled={value ? false : true}
                                                    onInputChange={e => this.onEnterText(e.target.value, area.id)}
                                                    onChange={() => this.handleAreas(area.id, value, area)}
                                                    onAddArea={() => this.onAddArea(area.id)}
                                                />
                                            </Col>
                                        )
                                    })
                                    }
                                </Row>





                            </Col>
                        </Row>
                    </>
                )}
            />
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    user: selectAuthenticatedUser(state),
    commonAreas: selectCommonAreas(state),
    propertyCommonAreas: selectPropertyCommonAreas(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({
    onSaveProperyCommonAreas: savePropertyCommonAreas
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureCommonAreaForm)

